import React, { useEffect, useState } from 'react';
import { Button, Cell, CardTitle, DialogContainer, Grid } from 'react-md';
import { NotificationManager } from 'react-notifications';
import ApiRequestService from './ApiRequestService.js';
import LoadingSpinner from './LoadingSpinner.js';
import QuizDropDown from './QuizDropDown.js';
import { AppProperties } from '../common/function.js';
import { MenuItem, Select,InputLabel,Typography,Box,FormControl } from '@mui/material';
import CustomSegmentedControl from '../lib/components/CustomSegementedControl';
import styles from "../css/styles.css.js";
import MultiSelectReact from 'react-multi-select-ext';

const labels = [
    { label: 'From Any Semester', value: 'semester', default: true },
    { label: 'From Assignment Matrix Library', value: 'library', default: false },
];

const selectedOptionsStyles = {
    color: '#FFFFFF',
    backgroundColor: '#bb0000'
};
const optionsListStyles = {
    backgroundColor: '#FFFFFF',
    color: '#bb0000'
};

// toLibrary turns the dialog around: the same semester / course / section /
// assignment pickers, but the target is a library matrix instead of a section
// of the current course. The targetLibrary* props name that matrix;
// onUnsyncedCategories receives the refusal when the matrix is syncing and the
// assignments carry categories the other universities do not have;
// onDeletedCategories the one, checked first, when they carry categories that
// have been deleted from the question bank since.
const ImportAssignmentDialog = ({ visible, onHide, courseID, fromMatrixPage, onCompleteCopyQuiz,CurrentCourses,CurrentSelectedCourse,
    toLibrary, targetLibrarySubjectID, targetLibraryTopicID, targetLibraryMatrixID, targetLibraryMatrixName, onUnsyncedCategories, onDeletedCategories }) => {

    const [loading, setLoading] = useState(false);
    const [sectionLoading, setSectionLoading] = useState(false);
    const [courseLoading, setCourseLoading] = useState(false);
    const [quizLoading, setQuizLoading] = useState(false);
    const [course, setCourse] = useState({});
    const [courses, setCourses] = useState([]);
    const [sections, setSections] = useState([]);
    const [semesters, setSemesters] = useState([]);
    const [quizzes, setQuizzes] = useState([]);
    const [selectedQuizIds, setSelectedQuizIds] = useState([]);
    const [selectedQuizIdArray, setSelectedQuizIdArray] = useState([]);

    const [selectSectionID, setSelectSectionID] = useState(0);
    const [semesterID, setSemesterID] = useState("");
    const [selectedCourseID, setSelectedCourseID] = useState(0);
    const [targetSection, setTargetSections] = useState([]);
    const [targetSectionLoading, setTargetSectionLoading] = useState(false);
    const [selectTargetSectionID, setSelectTargetSectionID] = useState(0);
    const [selectedTab, setSelectedTab] = useState("semester");
    const [librarySubjects, setLibrarySubjects] = useState([]);
    const [librarySubjectID, setLibrarySubjectID] = useState(null);
    const [libraryTopics, setLibraryTopics] = useState([]);
    const [libraryTopicID, setLibraryTopicID] = useState(null);
    const [libraryAssignments, setLibraryAssignments] = useState([]);

    const [libraryMatrices, setLibaryMatrices] = useState([]);
    const [libraryMatricesMultiSelectList, setLibaryMatricesMultiSelectList] = useState([]);

    const [selectedMatrixIDArray, setSelectedMatrixIDArray] = useState([]);
    const actions = [];

    const onCopyClicked = () => {
        let payload = {
            semesterID: semesterID, currentCourseID: courseID, courseID: selectedCourseID, quizesIDs: selectedQuizIdArray,
            startDate: "",
            startTime: "00:00:00",
            endDate: "",
            endTime: "00:00:00",
            sectionIDs: [selectTargetSectionID]
        };

        setLoading(true);
        ApiRequestService({
            method: 'post',
            url: "/copyAllQuiz",
            data: payload
        })
            .then(res => {
                if (
                    res && res.data && res.data.data
                ) {
                    NotificationManager.success('Imported all assignments successfully!', 'Success', 3000);
                    //Redirect to the Quiz Page
                    if (fromMatrixPage) {
                        onCompleteCopyQuiz();
                    } else {
                        window.location.reload();
                    }
                }
            })
            .catch(error => {
                console.error('Error When Importing Quizes ', error);
                NotificationManager.error(error, "Error", 5000);

            }).finally(() => {
                resetDefaultState()
                onHide();
            });

    }

    const onHideandAll = () => {
        resetDefaultState()
        onHide();
    };

    const resetDefaultState = ()=>{
        setSemesterID("")
        setCourse({});
        setCourses([])
        setSelectedCourseID(0)
        setSections([])
        setSelectSectionID(0);
        setSelectedQuizIds([])
        setSelectedQuizIdArray([]);
        setQuizzes([]);
        setTargetSections([]);
        setSelectTargetSectionID(0);
        setLoading(false);
        setQuizLoading(false);
        setSectionLoading(false);
        setCourseLoading(false);
        setTargetSectionLoading(false);
        setSelectedTab("semester");
        setLibrarySubjects([]);
        setLibrarySubjectID(null);
        setLibraryTopics([]);
        setLibraryTopicID(null);
        setLibraryAssignments([]);
        clearMatrixSelection();
    }

    // The matrix list and its selection are cleared together: the multiselect
    // tracks selection by mutating its own option objects, so a stale list is
    // also a stale selection.
    const clearMatrixSelection = () => {
        setLibaryMatrices([]);
        setLibaryMatricesMultiSelectList([]);
        setSelectedMatrixIDArray([]);
    }

    const onCourseChange = (event) => {
        let selectedCourseID = event.target.value;
        let selectedCourse = courses.find(course => course.course_id === selectedCourseID);
        setCourse(selectedCourse);
        setSelectedCourseID(selectedCourseID);
        setSelectedQuizIdArray([]);
        setSelectSectionID(0);
        setSections([]);
        setQuizzes([]);
        setTargetSections([]);
        setSelectTargetSectionID(0);
        if(selectedCourseID){
             getSections(selectedCourseID,semesterID);
        }
    };

    //On Section Selected
    const onQuizChange = (argSelectedQuizIDs) => {
        let quizIds = []
        argSelectedQuizIDs.forEach(row => {
            if (row.value && row.id !== 'enableAll' && row.id !== 'enableNone') {
                quizIds.push(row.id);
            }
        })
        setSelectedQuizIds([...argSelectedQuizIDs])
        setSelectedQuizIdArray([...quizIds])
    };

    const onMatrixChange = (argSelectedQuizIDs) => {
        let matrixIDs = []
        argSelectedQuizIDs.forEach(row => {
            if (row.value && row.id !== 'enableAll' && row.id !== 'enableNone') {
                matrixIDs.push(row.id);
            }
        })
        setSelectedMatrixIDArray([...matrixIDs])
    };

    const onSemesterChange = (event) => {
        let semesterID = event.target.value;
        setSemesterID(semesterID);
        // emoty other dropdown data's
        setCourse([]);
        setCourses([]);
        setSelectedCourseID(0)
        setSelectedQuizIdArray([]);
        setSelectSectionID(0)
        setSections([]);
        setQuizzes([]);
        setTargetSections([]);
        setSelectTargetSectionID(0);
        getCoursesFromSemester(semesterID);
    };


    const getAllSemesters = async () => {
        let getAllSemestersResp = await ApiRequestService({
            method: 'post',
            url: '/getAllSemesters'
        });

        try {
            if (getAllSemestersResp && getAllSemestersResp.data && getAllSemestersResp.data.data) {
                return getAllSemestersResp.data.data;
            } else if (getAllSemestersResp.data && getAllSemestersResp.data.status && getAllSemestersResp.data.message) {
                NotificationManager.error("Get All Semesters Failed with Error - " + getAllSemestersResp.data.message, "Error", 5000);
            } else {
                NotificationManager.error("Get All Semesters Failed with Unknown Error", "Error", 5000);
            }
        } catch (err) {
            NotificationManager.error("Get All Semesters Failed with Error " + err, "Error", 5000);
        }

        return null;
    }

    const onload = () => {
        getAllSemesters().then(semesters => {
            if (semesters) {
                // const prevSemesters = semesters.filter(semester => semester.isCurrent != true);
                // setSemesters([...prevSemesters]);
                let tempSemesters = semesters.map(sem => {
                    if (sem.isCurrent) {
                        sem.name = sem.name + " (Current)"
                    }
                    return sem;
                })
                setSemesters(tempSemesters);
            }
        })
    }
    useEffect(onload, []);

    const getCoursesFromSemester = (semesterID) => {
        setCourses([]);
        setCourseLoading(true);
        const payload = { id: semesterID };
        ApiRequestService({
            method: 'post',
            url: '/getAllCoursesForSemester',
            data: payload
        })
            .then(res => {
                setCourseLoading(false);

                if (res.data !== undefined && res.data !== null &&
                    res.data.data !== undefined && res.data.data !== null &&
                    res.data.data.course_names !== undefined &&
                    res.data.data.course_names !== null &&
                    res.data.data.course_names.length > 0) {
                    setCourses([...res.data.data.course_names]);
                } else {
                    setCourses([]);
                    NotificationManager.error(
                        "You do not have access to view or no courses in the selected semester.\n\nPlease contact your administrator to request access.",
                        "Access Denied",
                        6000
                    );
                }
            })
            .catch(error => {
                setCourses([]);
                console.error('Error When Retriving Course Details ', error);
            });
    };

    const getQuizsFromCourse = (prevCourseID,semesterID,sectionID) => {
        setQuizzes([]);
        setQuizLoading(true);
        const payload = { course_id: prevCourseID, section_Id: sectionID,archiveMode: true, semesterID: semesterID };
        ApiRequestService({
            method: 'post',
            url: '/getAllQuiz',
            data: payload
        })
            .then(res => {
                setQuizLoading(false);

                if (res.data !== undefined && res.data !== null &&
                    res.data.data !== undefined && res.data.data !== null &&
                    res.data.data.quizes_list !== undefined &&
                    res.data.data.quizes_list !== null &&
                    res.data.data.quizes_list.length > 0) {
                    setQuizzes([...res.data.data.quizes_list]);
                } else {
                    setQuizzes([]);
                    NotificationManager.error("No assignments found in the selected section.");               
                }
            })
            .catch(error => {
                console.error('Error When Retriving Course Details ', error);
            }).finally(() => {
                setQuizLoading(false);
                if (!toLibrary) {
                    getCurrentCourseSections(courseID);
                }
            });
    
    };

    const getCurrentCourseSections = (courseID) => {
        setTargetSections([]);
        setTargetSectionLoading(true);
        const payload = { course_id: courseID };
        ApiRequestService({
            method: 'post',
            url: '/getAllSections',
            data: payload
        })
            .then(res => {
                setSectionLoading(false);

                if (
                    res && res.data && res.data.data &&
                    res.data.data.section_names &&
                    res.data.data.section_names.length > 0
                ) {
                    setTargetSections([...res.data.data.section_names]);
                } else {
                    NotificationManager.error("Please create atleast one section in your active course.");
                }
            })
            .catch(error => {
                console.error('Error When Retriving Section Details ', error);
            }).finally(() => {
                setTargetSectionLoading(false);
            });
    }

    const getSections =  (courseID,prevSemesterID) => {
        setSections([]);
        setSectionLoading(true);
        const payload = { course_id: courseID,semesterID: prevSemesterID };
        ApiRequestService({
            method: 'post',
            url: '/getSectionsBySemesterAndCourse',
            data: payload
        })
            .then(res => {
                setSectionLoading(false);

                if (
                    res && res.data && res.data.data &&
                    res.data.data.section_names &&
                    res.data.data.section_names.length > 0
                ) {
                    const section_list = res.data.data.section_names
                    setSections(section_list);
                } else {
                    NotificationManager.error("Please create atleast one section in your selected course.");
                }
            })
            .catch(error => {
                console.error('Error When Retriving Section Details ', error);
            });

    };

    const onSingleSectionSelected = (event) => {
        let sectionID = event.target.value;
        setSelectSectionID(sectionID)
        getQuizsFromCourse(selectedCourseID, semesterID, sectionID);
    }

    const onTargetSectionSelected = (event) => {
        let sectionID = event.target.value;
        setSelectTargetSectionID(sectionID)
    }

    // ─── Library Functions ───

    const getLibrarySubjects = () => {
        setCourseLoading(true);
        ApiRequestService({
            method: 'get',
            url: "/getAMLSubjects",
        }).then(res => {
            if (res && res.data && res.data.data) {
                setLibrarySubjects(res.data.data);
            } else {
                setLibrarySubjects([]);
            }
        }).finally(() => {
            setCourseLoading(false);
        });
    };

    const getLibraryTopics = (id) => {
        setCourseLoading(true);
        ApiRequestService({
            method: 'post',
            url: "/getAMLTopics",
            data: { aml_subject_id: id }
        }).then(res => {
            if (res && res.data && res.data.data) {
                setLibraryTopics(res.data.data);
            } else {
                setLibraryTopics([]);
            }
        }).finally(() => {
            setCourseLoading(false);
        });
    };

    const getLibraryAssignments = (payload) => {
        setQuizLoading(true);
        ApiRequestService({
            method: 'post',
            url: '/getLibraryAssignments',
            data: payload,
        }).then(res => {
            if (res && res.data && res.data.data) {
                let arr = res.data.data;
                setQuizzes(arr);
                let list = [];
                arr.forEach(quiz => {
                    list.push({
                        index: quiz.quiz_id,
                        label: quiz.quiz_name,
                        value: false,
                        id: quiz.quiz_id
                    });
                });
                setLibraryAssignments(list);
            } else {
                setQuizzes([]);
            }
        }).finally(() => {
            setQuizLoading(false);
        });
    };

    const getLibraryMatrices = (payload) => {
        setQuizLoading(true);
        ApiRequestService({
            method: 'post',
            url: '/getAMLMatrices',
            data: {
                ...payload,
                include_quiz_id: true,
            },
        }).then(res => {
            if (res && res.data && res.data.data) {
                let arr = res.data.data;
                setLibaryMatrices(arr);
                let list = [];
                arr.forEach(matrix => {
                    list.push({
                        index: matrix.id,
                        label: matrix.name,
                        value: false,
                        id: matrix.id
                    });
                });
                setLibaryMatricesMultiSelectList(list);
            } else {
                clearMatrixSelection();
            }
        }).finally(() => {
            setQuizLoading(false);
        });
    };

    const onLibrarySubjectChange = (event) => {
        let id = event.target.value;
        setLibrarySubjectID(id);
        setLibraryTopicID(null);
        setLibraryTopics([]);
        setLibraryAssignments([]);
        setQuizzes([]);
        setSelectedQuizIds([]);
        setSelectedQuizIdArray([]);
        setTargetSections([]);
        setSelectTargetSectionID(0);
        clearMatrixSelection();
        getLibraryTopics(id);
    };

    const onLibraryTopicChange = (event) => {
        let id = event.target.value;
        setLibraryTopicID(id);
        setLibraryAssignments([]);
        setQuizzes([]);
        setSelectedQuizIds([]);
        setSelectedQuizIdArray([]);
        setSelectTargetSectionID(0);
        clearMatrixSelection();
        // getLibraryAssignments({
        //     aml_subject_id: librarySubjectID,
        //     aml_topic_id: id,
        // });
        getLibraryMatrices({
            aml_subject_id: librarySubjectID,
            aml_topic_id: id,
        });
    };

    const onCopyToLibraryClicked = () => {
        let payload = {
            semesterID: semesterID,
            courseID: selectedCourseID,
            quizesIDs: selectedQuizIdArray,
            startDate: "",
            startTime: "00:00:00",
            endDate: "",
            endTime: "00:00:00",
            aml_subject_id: targetLibrarySubjectID,
            aml_topic_id: targetLibraryTopicID,
            aml_matrix_id: targetLibraryMatrixID,
        };

        setLoading(true);
        ApiRequestService({
            method: 'post',
            url: "/importAssignmentsToAMLMatrix",
            data: payload
        })
            .then(res => {
                const result = res && res.data ? res.data.data : null;
                if (!result) {
                    setLoading(false);
                    NotificationManager.error((res && res.data && res.data.message) || "Could not import the assignments", "Error", 5000);
                    return;
                }
                if (result.deleted_categories && result.deleted_categories.length > 0) {
                    // Refused, nothing copied. The picks stay so the import can
                    // be retried once the old assignments are fixed.
                    setLoading(false);
                    if (onDeletedCategories) {
                        onDeletedCategories(result.deleted_categories);
                    }
                    return;
                }
                if (result.validation && result.validation.valid === false) {
                    // Refused, nothing copied. Leave the picks in place so the
                    // import can be retried once the question bank has synced.
                    setLoading(false);
                    if (onUnsyncedCategories) {
                        onUnsyncedCategories(result.validation.unsynced_categories || []);
                    }
                    return;
                }
                NotificationManager.success('Imported all assignments successfully!', 'Success', 3000);
                resetDefaultState();
                onHide();
                onCompleteCopyQuiz(result.quiz_ids);
            })
            .catch(error => {
                console.error('Error When Importing Quizes To Library ', error);
                NotificationManager.error(error, "Error", 5000);
                resetDefaultState();
                onHide();
            });
    };

    const onLibraryCopyClicked = () => {
        let payload = {
            semesterID: 0,
            currentCourseID: courseID,
            courseID: 0,
            quizesIDs: [],
            startDate: "",
            startTime: "00:00:00",
            endDate: "",
            endTime: "00:00:00",
            sectionIDs: [selectTargetSectionID],
            isLibrary: true
        };
        let quizIDArr = [];
        libraryMatricesMultiSelectList.forEach(libMat => {
            if (libMat.value) {
                const matrixData = libraryMatrices.find(mat => mat.id === libMat.id)
                if (matrixData && matrixData.quiz_id_arr) {
                    quizIDArr.push(...matrixData.quiz_id_arr);
                }
            }
        })
        payload.quizesIDs = quizIDArr;
        if (payload.quizesIDs && payload.quizesIDs.length === 0) {
            NotificationManager.error("Please choose an assignment matrix that has assignments", "", 4000);
            return;
        }

        setLoading(true);
        ApiRequestService({
            method: 'post',
            url: "/copyAllQuiz",
            data: payload
        })
            .then(res => {
                if (res && res.data && res.data.data) {
                    NotificationManager.success('Imported all assignments successfully!', 'Success', 3000);
                    if (fromMatrixPage) {
                        onCompleteCopyQuiz();
                    } else {
                        window.location.reload();
                    }
                }
            })
            .catch(error => {
                console.error('Error When Importing Quizes ', error);
                NotificationManager.error(error, "Error", 5000);
            }).finally(() => {
                resetDefaultState();
                onHide();
            });
    };

    useEffect(() => {
        if (librarySubjectID && libraryTopicID) {
            getCurrentCourseSections(courseID);
        }
    }, [librarySubjectID, libraryTopicID]);

    const tabOnChange = (val) => {
        setSelectedTab(val);
        // Clear shared state to avoid stale data leaking between tabs
        setQuizzes([]);
        setSelectedQuizIds([]);
        setSelectedQuizIdArray([]);
        setTargetSections([]);
        setSelectTargetSectionID(0);
        setQuizLoading(false);
        setTargetSectionLoading(false);
        if (val === "library") {
            setSemesterID("");
            setCourse({});
            setCourses([]);
            setSelectedCourseID(0);
            setSections([]);
            setSelectSectionID(0);
            getLibrarySubjects();
        } else {
            setLibrarySubjectID(null);
            setLibrarySubjects([]);
            setLibraryTopicID(null);
            setLibraryTopics([]);
            setLibraryAssignments([]);
        }
    };

    //Reset on Dialog Load
    useEffect(() => {
        if (visible) {
            resetDefaultState();
        }
    }, [visible])
 //Buttons
    actions.push({ secondary: true, children: 'Cancel', onClick: onHideandAll });
    actions.push(<Button raised primary onClick={() => {
        if (toLibrary) {
            onCopyToLibraryClicked();
        } else if (selectedTab === "semester") {
            onCopyClicked();
        } else {
            onLibraryCopyClicked();
        }
    }}
        disabled={
            toLibrary
                ? (!course || !selectSectionID || selectSectionID.length <= 0 || selectedQuizIdArray.length <= 0 || loading)
                : selectedTab === "semester"
                ? (!course || !selectSectionID || selectSectionID.length <= 0 || !courseID || !selectTargetSectionID || targetSection.length <=0 || selectedQuizIdArray.length <=0  ||loading)
                
                : (!librarySubjectID || !libraryTopicID || !selectTargetSectionID || targetSection.length <=0 || selectedMatrixIDArray.length <=0 || loading)
        }>
        Import
    </Button>);

    return <DialogContainer
        id="copy-all-quiz-dialog"
        title={toLibrary ? "Import Assignments Into Matrix Library" : "Import Assignments From Any Semester"}
        visible={visible}
        onHide={onHide}
        contentClassName="md-grid copy-quiz-dialog"
        aria-describedby="copy-quiz-instructions"
        modal
        actions={actions}
        width={'70%'}
        style={{
            zIndex: 999,
        }}
    >
        {toLibrary ? null :
        <CustomSegmentedControl
            options={labels}
            setValue={(newValue) => tabOnChange(newValue)}
            style={{
                ...styles.categorySegmentedControl,
                width: "100%",
            }}
        />}
        {
            loading ?
                <React.Fragment>
                    <Cell size={12} > <LoadingSpinner cls={{ margin: '10%' }} loading={loading} /> </Cell>
                </React.Fragment>

                :

                <React.Fragment>

                    {selectedTab === "semester" ?
                     <Box style={{marginTop:"8px"}} display="flex" flexDirection="column" alignItems="center" gap={1}>

                        <Box
                            sx={{
                            border: '1px solid #ccc',
                            borderRadius: '6px',
                            p: 1.5,
                            display: 'inline-block',
                            width: '100%',
                            marginBottom: '0px'
                            }}
                            fullWidth
                        >
                            <Grid style={{ margin: "0rem 0rem", padding: "0" }}>

                                <Typography
                                fontSize={15}
                                fontWeight={600}
                                sx={{
                                    whiteSpace: 'nowrap',
                                    width: 'fit-content',
                                    marginLeft: '10px'
                                }}
                                >
                                Semester
                                </Typography>
                                    <Cell size={12} id="copy-quiz-instructions" style={{display:"flex"}} className='md-body-4'>
                                        Please select a semester, a course, a section and one or more assignments.
                                    </Cell>
                                    <Cell size={4}>
                                         <FormControl fullWidth>

                                            <InputLabel id="selectSemesterslist">Semester</InputLabel>
                                            <Select
                                                labelId="selectSemesterslist"
                                                id="select-semester-list"
                                                label="Semester"
                                                onChange={onSemesterChange}
                                                fullWidth
                                                value={semesterID}>
                                                    {semesters?.map((semester, index) => {
                                                        return <MenuItem key={semester.id} value={semester.id}>
                                                            {semester.name}
                                                        </MenuItem>
                                                    })}
                                            </Select>
                                         </FormControl>
                                    </Cell>
                                    <Cell size={4}>
                                        {
                                            courseLoading ?
                                                <LoadingSpinner cls={{ margin: '10%' }} loading={courseLoading} />
                                                :

                                                courses.length > 0 && semesters.length > 0 ?
                                                    <FormControl fullWidth>

                                                        <InputLabel id="prevSemesterselectCourses">Course</InputLabel>
                                                        <Select
                                                            labelId="prevSemesterselectCourses"
                                                            id="prevSemesterselectCourses"
                                                            onChange={onCourseChange}
                                                            label="Course"
                                                            value={selectedCourseID}
                                                            fullWidth
                                                        >

                                                            {courses?.map((course, index) => {
                                                                    return <MenuItem key={course.course_id} value={course.course_id}>
                                                                        {course.course_name}
                                                                    </MenuItem>
                                                                })}
                                                        </Select>
                                                    </FormControl>
                                                    :
                                                    ""
                                        }
                                    </Cell>
                                    <Cell size={4}>
                                        {
                                            sectionLoading ?
                                                <LoadingSpinner cls={{ margin: '10%' }} loading={sectionLoading} />
                                                :

                                                sections.length > 0  ?
                                                     <FormControl fullWidth>
                                                        <InputLabel id="selectPreviousSections">Section</InputLabel>
                                                        <Select
                                                            labelId="selectPreviousSections"
                                                            id="selectPreviousSections"
                                                            onChange={onSingleSectionSelected}
                                                            label="Sections"
                                                            value={selectSectionID}
                                                            fullWidth
                                                        >

                                                            {sections?.map((section, index) => {
                                                                    return <MenuItem key={section.section_id} value={section.section_id}>
                                                                        {section.section_name}
                                                                    </MenuItem>
                                                                })}
                                                        </Select>
                                                    </FormControl> :
                                                undefined
                                        }
                                    </Cell>
                                
                                <Cell size={12}>
                                        {
                                            quizLoading ?
                                                <LoadingSpinner cls={{ margin: '10%' }} loading={quizLoading} />
                                                :

                                                quizzes.length > 0 && (course && course != []) ?
                                                    <>
                                                        <CardTitle style={{ padding: '0px', marginBottom: '8px', fontSize: '13px' }}>Assignments</CardTitle>
                                                        <QuizDropDown
                                                            NoLoader={true}
                                                            selectedCourseID={course}
                                                            selectedSemesterID={semesterID}
                                                            sectionID={selectSectionID}
                                                            selectBoxID="sectionSelectBox"
                                                            placeholder="Select Assignments"
                                                            fullWidth
                                                            archiveMode={true}
                                                            onChange={onQuizChange}
                                                            className=" gradebook-dropdown"
                                                            selectAll={false}
                                                            showSelectAll={true}
                                                            perfDataMode={true} />
                                                    </>
                                                    :
                                                    undefined
                                        }
                                    </Cell>
                            </Grid>
                        </Box>
                         {
                            !toLibrary && targetSection?.length > 0 && quizzes?.length > 0 ?

                                <Box
                                sx={{
                                    width: "12px",             // thickness of connector
                                    height: "35px",            // gap between boxes
                                    backgroundColor: "#bb0000",// solid bold line
                                    position: "relative",
                                    m: 0,
                                    p: 0,
                                }}
                                >
                                {/* Arrowhead */}
                                <Box
                                    sx={{
                                    position: "absolute",
                                    bottom: -10, 
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    width: 0,
                                    height: 0,
                                    borderLeft: "17px solid transparent",
                                    borderRight: "17px solid transparent",
                                    borderTop: "17px solid #bb0000", 
                                    }}
                                />
                                </Box>
                            :""
                        }

                    {
                        toLibrary && selectedQuizIdArray.length > 0 ?
                            <Cell position={'left'} size={12}>
                                <CardTitle style={{ padding: '0px', marginTop: '10px', fontSize: '13px' }}>
                                    The selected assignments will be added to the library matrix { " " }<strong>{targetLibraryMatrixName}</strong>.
                                    They will have no start or end dates assigned and will remain unpublished.
                                </CardTitle>
                            </Cell>
                        : null
                    }
                    {
                        !toLibrary && targetSection.length > 0 && quizzes?.length > 0 ?
                            <Box
                                sx={{
                                border: '1px solid #ccc',
                                borderRadius: '6px',
                                p: 1.5,
                                display: 'inline-block',
                                width: '100%',
                                marginTop: '5px'
                                }}
                            >
                                <Grid style={{ margin: "0rem 0rem", padding: "0" }}>
                                    <Typography
                                        fontSize={15}
                                        fontWeight={600}
                                        sx={{
                                            whiteSpace: 'nowrap',
                                            width: 'fit-content',
                                            marginLeft: '10px'
                                        }}
                                        >
                                        Current Semester
                                        </Typography>
                                        <Cell size={12}>

                                                {
                                                    targetSectionLoading ?
                                                        <LoadingSpinner cls={{ margin: '10%' }} loading={targetSectionLoading} /> 
                                                        : targetSection.length > 0 ?
                                                                <>
                                                                <CardTitle style={{ padding: '0px', fontSize: '13px',marginBottom:"10px" }}>
                                                                Select a section in current course { " " } <strong>({CurrentSelectedCourse?.course_name})</strong> { " " } to import the assignments
                                                                </CardTitle>
                                                                <FormControl fullWidth>
                                                                <InputLabel id="selectCurrentSections">Section</InputLabel>
                                                                    <Select
                                                                        labelId="selectCurrentSections"
                                                                        id="selectCurrentSections-list"
                                                                        onChange={onTargetSectionSelected}
                                                                        label="Sections"
                                                                        value={selectTargetSectionID}
                                                                        fullWidth
                                                                    >

                                                                        {targetSection?.map((section, index) => {
                                                                                return <MenuItem key={section.section_id} value={section.section_id}>
                                                                                    {section.section_name}
                                                                                </MenuItem>
                                                                            })}
                                                                    </Select>
                                                              </FormControl>
                                                                </>
                                                            : "The current course doesn’t have any sections. Please create a section under this course."
                                                }
                                        </Cell>
                                    
                                        <Cell position={'left'} size={12}>
                                            {selectTargetSectionID > 0 ?
                                                <CardTitle style={{ padding: '0px', marginBottom: '10px', fontSize: '13px' }}>
                                                    NOTE:  All assignments being imported will have no start or end dates assigned and will remain unpublished.
                                                </CardTitle> : undefined}
                                        </Cell>

                                    
                            </Grid> 

                            </Box>

                        : ''
                    }
                    {
                         semesterID && (toLibrary || courseID) && selectSectionID && quizzes.length === 0 && !quizLoading ?
                         `No assignments found in the selected section.`:"" 
                    }
                    {
                         !toLibrary && semesterID && targetSection.length === 0 && courseID && selectSectionID && !targetSectionLoading && quizzes.length > 0 ?
                         `The current course doesn't have any sections.`:"" 
                    }
                     </Box>
                    : null}

                    {selectedTab === "library" ?
                        <Box style={{marginTop: "8px"}} display="flex" flexDirection="column" alignItems="center" gap={1}>
                            <Box
                                sx={{
                                    border: '1px solid #ccc',
                                    borderRadius: '6px',
                                    p: 1.5,
                                    display: 'inline-block',
                                    width: '100%',
                                    marginBottom: '0px'
                                }}
                                fullWidth
                            >
                                <Grid style={{ margin: "0rem 0rem", padding: "0" }}>
                                    <Typography
                                        fontSize={15}
                                        fontWeight={600}
                                        sx={{
                                            whiteSpace: 'nowrap',
                                            width: 'fit-content',
                                            marginLeft: '10px'
                                        }}
                                    >
                                        Assignment Matrix Library
                                    </Typography>
                                    <Cell size={12} id="library-instructions" style={{display:"flex"}} className='md-body-4'>
                                        Please select a matrix library subject and topic
                                    </Cell>
                                    <Cell size={4}>
                                        <FormControl fullWidth>
                                            <InputLabel id="selectLibrarySubject">Library Subject</InputLabel>
                                            <Select
                                                labelId="selectLibrarySubject"
                                                id="select-library-list"
                                                label="Library Subject"
                                                onChange={onLibrarySubjectChange}
                                                fullWidth
                                                value={librarySubjectID || ''}>
                                                {librarySubjects?.map((subject, index) => {
                                                    return <MenuItem key={subject.id} value={subject.id}>
                                                        {subject.name}
                                                    </MenuItem>
                                                })}
                                            </Select>
                                        </FormControl>
                                    </Cell>
                                    <Cell size={4}>
                                        {
                                            libraryTopics?.length > 0 ?
                                                <FormControl fullWidth>
                                                    <InputLabel id="libraryTopic">Library Topic</InputLabel>
                                                    <Select
                                                        labelId="libraryTopic"
                                                        id="libraryTopicSelect"
                                                        onChange={onLibraryTopicChange}
                                                        label="Library Topic"
                                                        value={libraryTopicID || ''}
                                                        fullWidth
                                                    >
                                                        {libraryTopics?.map((topic, index) => {
                                                            return <MenuItem key={topic.id} value={topic.id}>
                                                                {topic.name}
                                                            </MenuItem>
                                                        })}
                                                    </Select>
                                                </FormControl>
                                                : ""
                                        }
                                    </Cell>

                                    {quizLoading ?
                                        <Cell size={12}>
                                            <LoadingSpinner cls={{ margin: '10%' }} loading={quizLoading} />
                                        </Cell>
                                        :
                                        libraryMatricesMultiSelectList.length > 0 ?
                                            <Cell size={12}>
                                                <CardTitle style={{ padding: '0px', marginBottom: '8px', fontSize: '13px' }}>
                                                    Assigment Matrices
                                                </CardTitle>
                                                <MultiSelectReact
                                                    options={libraryMatricesMultiSelectList}
                                                    optionClicked={onMatrixChange}
                                                    selectedBadgeClicked={onMatrixChange}
                                                    selectedOptionsStyles={selectedOptionsStyles}
                                                    optionsListStyles={optionsListStyles}
                                                    enableSelectAllNone={true}
                                                />
                                            </Cell>
                                            : null
                                    }
                                </Grid>
                            </Box>

                            {libraryMatrices?.length > 0 ?
                                <Box
                                    sx={{
                                        width: "12px",
                                        height: "35px",
                                        backgroundColor: "#bb0000",
                                        position: "relative",
                                        m: 0,
                                        p: 0,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            bottom: -10,
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            width: 0,
                                            height: 0,
                                            borderLeft: "17px solid transparent",
                                            borderRight: "17px solid transparent",
                                            borderTop: "17px solid #bb0000",
                                        }}
                                    />
                                </Box>
                                : ""
                            }

                            {libraryMatrices?.length > 0 ?
                                <Box
                                    sx={{
                                        border: '1px solid #ccc',
                                        borderRadius: '6px',
                                        p: 1.5,
                                        display: 'inline-block',
                                        width: '100%',
                                        marginTop: '5px'
                                    }}
                                >
                                    <Grid style={{ margin: "0rem 0rem", padding: "0" }}>
                                        <Typography
                                            fontSize={15}
                                            fontWeight={600}
                                            sx={{
                                                whiteSpace: 'nowrap',
                                                width: 'fit-content',
                                                marginLeft: '10px'
                                            }}
                                        >
                                            Current Semester
                                        </Typography>
                                        <Cell size={12}>
                                            {
                                                targetSectionLoading ?
                                                    <LoadingSpinner cls={{ margin: '10%' }} loading={targetSectionLoading} />
                                                    : targetSection?.length > 0 ?
                                                        <>
                                                            <CardTitle style={{ padding: '0px', fontSize: '13px', marginBottom: "10px" }}>
                                                                Select a section in current course {" "} <strong>({CurrentSelectedCourse?.course_name})</strong> {" "} to import the assignments
                                                            </CardTitle>
                                                            <FormControl fullWidth>
                                                                <InputLabel id="selectCurrentSectionsLibrary">Section</InputLabel>
                                                                <Select
                                                                    labelId="selectCurrentSectionsLibrary"
                                                                    id="selectCurrentSectionsLibrary-list"
                                                                    onChange={onTargetSectionSelected}
                                                                    label="Sections"
                                                                    value={selectTargetSectionID}
                                                                    fullWidth
                                                                >
                                                                    {targetSection?.map((section, index) => {
                                                                        return <MenuItem key={section.section_id} value={section.section_id}>
                                                                            {section.section_name}
                                                                        </MenuItem>
                                                                    })}
                                                                </Select>
                                                            </FormControl>
                                                        </>
                                                        : "The current course doesn't have any sections. Please create a section under this course."
                                            }
                                        </Cell>
                                        <Cell position={'left'} size={12}>
                                            {selectTargetSectionID > 0 ?
                                                <CardTitle style={{ padding: '0px', marginBottom: '10px', fontSize: '13px' }}>
                                                    NOTE:  All assignments being imported will have no start or end dates assigned and will remain unpublished.
                                                </CardTitle> : undefined}
                                        </Cell>
                                    </Grid>
                                </Box>
                                : ''
                            }
                        </Box>
                    : null}

                </React.Fragment>
        }
    </DialogContainer>
};

export default ImportAssignmentDialog;